// extracted by mini-css-extract-plugin
export default {"skeletonWrapper":"styles_skeletonWrapper__Q9kbs","skeleton":"styles_skeleton__7nkP-","loading":"styles_loading__15g+R"};